import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SubProject } from 'src/app/model/project/sub-project';
import { ProperPageResult } from 'src/app/model/proper-page-result';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _get } from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ClientCornerHomePageCompletedSubProjectsControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res: ProperPageResult<SubProject>) =>
    res == null ? null : res.items;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };

    this.get = _get(
      '/subprojects/client-home-page/completed/',
      requestServices
    );
  }

  public completedSubProjects(companyId: number): Promise<SubProject[]> {
    const path = `${companyId}?page=0&size=5&sortProperty=currentExecutionDate&sortDirection=DESC`;
    return this.get(path, this.deserialize).toPromise();
  }
}
